import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, Entity, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { ClientesServicios } from "../ClientesServicios/ClientesServicios";
import { ClientesTiendasServicios } from "./ClientesTiendasServicios";

export const ACTSeleccionarServicios: EntityClientAction = {
    name: 'ACTSeleccionarServicios',
    label: 'Seleccionar servicios',
    title: <Text fw={700}>Seleccionar servicios</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        // cast entity
        const parent = entity as ClientesTiendasServicios;
        const servicios = new ClientesServicios(entity.API.client);
        servicios.parentKeys = parent.parentKeys;

        if (modal) {
            await modal.open({
                modalProps: {
                    title: <Text fw="700">Seleccionar servicios</Text>,
                    size: 'xl'
                },
                focusOnClosed: element,
                content: <LookupFormAction
                    lookupEntity={servicios}
                    viewName={servicios.def.views.clse_brwStandard.name}
                    title="Agregar servicios seleccionados"
                    onActionFinished={async () => { if (onClose) await onClose(); }}
                    onOK={
                        async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                            const clientes_tiendas_servicios = Entity.clone(parent) as ClientesTiendasServicios;

                            clientes_tiendas_servicios.def.columns.c_cliente_id.value = parent.parentKeys[clientes_tiendas_servicios.def.columns.c_cliente_id.name] as string;
                            clientes_tiendas_servicios.def.columns.c_tienda_id.value = parent.parentKeys[clientes_tiendas_servicios.def.columns.c_tienda_id.name] as string;

                            const result = await clientes_tiendas_servicios.API.addData(abortSignal, keys, true);

                            return result;
                        }
                    }
                />

            });
        }
        else {
            console.log('modal context not found');
        }

        return Promise.resolve(false);

    }

}

